import React, { useEffect } from "react";
import st from "../../style.module.scss";
import { Form } from "react-bootstrap";
import { FaRegCircle } from "react-icons/fa";
import { MdDelete } from "react-icons/md";

const AddScorePointsRange = ({
    nestIndex,
    k,
    register,
    watch,
    setError,
    clearErrors,
    errors,
    remove }) => {

    const min = watch(`noOfYears.${nestIndex}.children.${k}.min`);
    const max = watch(`noOfYears.${nestIndex}.children.${k}.max`);

    useEffect(() => {
        if (min && max && +min >= +max) {
            setError(`noOfYears.${nestIndex}.children.${k}.min`, {
                type: "validate",
                message: "Min must be less than Max",
            });
            setError(`noOfYears.${nestIndex}.children.${k}.max`, {
                type: "validate",
                message: "Max must be greater than Min",
            });
        } else {
            if (min && max && +min < +max) {
                clearErrors(`noOfYears.${nestIndex}.children.${k}.min`);
                clearErrors(`noOfYears.${nestIndex}.children.${k}.max`);
            }
        }
    }, [min, max, clearErrors, setError, nestIndex]);
    return (
        <Form.Group
            className={`${st.formField} ${st.new_formFields} d-flex gap-3`}
        >
            <span className="btn" style={{ paddingTop: "36px" }}>
                <FaRegCircle />
            </span>
            <div>
                <Form.Label
                    htmlFor={`noOfYears.${nestIndex}.children.${k}.min`}
                >
                    Min
                </Form.Label>
                <Form.Control
                    type="number"
                    placeholder="Min"
                    {...register(`noOfYears.${nestIndex}.children.${k}.min`, {
                        required: "Min is required"
                    })}
                    isInvalid={
                        !!errors.noOfYears?.[nestIndex]?.children?.[k]?.min
                    }
                />
                <Form.Control.Feedback type="invalid">
                    {errors.noOfYears?.[nestIndex]?.children?.[k]?.min?.message}
                </Form.Control.Feedback>
                {/* {errors.noOfYears?.[nestIndex]?.children?.[k]?.min?.message && <span className="text-danger">{errors.noOfYears?.[nestIndex]?.children?.[k]?.min?.message}</span>} */}
            </div>
            <div>
                <Form.Label
                    htmlFor={`noOfYears.${nestIndex}.children.${k}.max`}
                >
                    Max
                </Form.Label>
                <Form.Control
                    type="number"
                    placeholder="Max"
                    {...register(`noOfYears.${nestIndex}.children.${k}.max`, {
                        required: "Max is required"
                    })}
                    isInvalid={
                        !!errors.noOfYears?.[nestIndex]?.children?.[k]?.max
                    }
                />
                <Form.Control.Feedback type="invalid">
                    {errors.noOfYears?.[nestIndex]?.children?.[k]?.max?.message}
                </Form.Control.Feedback>
                {/* {errors.noOfYears?.[nestIndex]?.children?.[k]?.max?.message && <span className="text-danger">{errors.noOfYears?.[nestIndex]?.children?.[k]?.max?.message}</span>} */}
            </div>

            <div>
                <Form.Label
                    htmlFor={`noOfYears.${nestIndex}.children.${k}.label`}
                >
                    Points Label
                </Form.Label>
                <Form.Control
                    type="text"
                    placeholder="label"
                    {...register(`noOfYears.${nestIndex}.children.${k}.label`, {
                        required: "label is required",
                    })}
                    isInvalid={
                        !!errors.noOfYears?.[nestIndex]?.children?.[k]?.label
                    }
                />
                <Form.Control.Feedback type="invalid">
                    {errors.noOfYears?.[nestIndex]?.children?.[k]?.label?.message}
                </Form.Control.Feedback>
                {/* {errors.noOfYears?.[nestIndex]?.children?.[k]?.label?.message && <span className="text-danger">This field is required</span>} */}
            </div>
            <div>
                <Form.Label
                    htmlFor={`noOfYears.${nestIndex}.children.${k}.riskLabel`}
                >
                    Risk Label
                </Form.Label>
                <Form.Control
                    type="text"
                    placeholder="Risk profile"
                    {...register(
                        `noOfYears.${nestIndex}.children.${k}.riskLabel`,
                        {
                            required: "label is required",
                        }
                    )}
                    isInvalid={
                        !!errors.noOfYears?.[nestIndex]?.children?.[k]?.riskLabel
                    }
                />
                <Form.Control.Feedback type="invalid">
                    {
                        errors.noOfYears?.[nestIndex]?.children?.[k]?.riskLabel
                            ?.message
                    }
                </Form.Control.Feedback>
                {/* {errors.noOfYears?.[nestIndex]?.children?.[k]?.riskLabel?.message && <span className="text-danger">This field is required</span>} */}
            </div>
            <div className="ps-2">
                <Form.Label>Action</Form.Label>
                <button className="btn" type="button" onClick={() => remove(k)}>
                    <MdDelete />
                </button>
            </div>
        </Form.Group>
    )
}

export default AddScorePointsRange